const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <h1>Your Space</h1>
    </div>
  );
};
export default LoadingScreen;
